import React from "react";

import { Outlet } from "react-router-dom";
import Sidebar from '../sidebar';
import Logo from './logo.png';

import ABTALogo from './abta.png';
import BCorpLogo from './b-corp.png';
import PCILogo from './pci.png';
import TravelLogo from './travel.png';
import './index.scss';

const pickText = () => {
  const path = window.location.pathname;

  if (path.includes('bank')) {
    return {
      title: 'Merchant Bank Details',
      subtitle: 'Please provide your bank and card processing details',
    }
  }

  if (path.includes('people-with-significant-control')) {
    return {
      title: 'People with Significant Control',
      subtitle: 'Please provide information about the people with significant control of your business',
    }
  }

  if (path.includes('status')) {
    return {
      title: 'Application Status',
      subtitle: 'Your application is being processed',
    }
  }

  return {
    title: 'Merchant Onboarding',
    subtitle: 'Welcome to the felloh merchant onboarding process',
  }
}

const Layout = () => {
  const text = pickText();

  return (
    <React.Fragment>
      <main>
        <div className="bg-gray-50 flex min-h-screen">

          <div className="w-1/2 flex min-h-screen hidden lg:block bg-purple-800">
            <div className="max-w-xl m-auto justify-center items-center mt-10">
              <a href="https://felloh.com">
                <img
                  className="logo-dark logo-img max-h-[60px] -ml-4"
                  src={Logo}
                  alt="logo"
                />
              </a>
              <p className="text-white text-5xl mt-20 font-bold">
                {text.title}
              </p>
              <p className="text-white text-xl font-normal mt-2">{ text.subtitle }</p>

              <p className="text-white text-xl font-thin mt-8">We require information about your business so that we...</p>
              <ul className="max-w-xl space-y-5 text-white list-outside list-disc mt-8 ml-6 text-md font-thin">
                <li>
                  <span className='text-xl'>Can meet our regulatory requirements</span>
                </li>

                <li>
                  <span className='text-xl'>Can formulate a fee schedule</span>
                </li>

                <li>
                  <span className='text-xl'>Can enable you to start accepting payments</span>
                </li>

              </ul>


              <p className='text-white text-md font-thin mt-8'>*These checks will not affect your credit score.</p>

              <div className="flex mt-12">
                <img src={BCorpLogo} alt="BCorp" className="h-16 mr-6" />
                <img src={PCILogo} alt="PCI" className="h-10 mt-4 ml-4 mr-8" />
                <img src={TravelLogo} alt="Travel" className="h-12 mt-2 mr-7" />
                <img src={ABTALogo} alt="ABTA" className="h-12 mt-2" />
              </div>

            </div>
          </div>

          <div className="lg:px-24 lg:py-12 md:p-52 sm:20 p-8 w-full min-h-screen lg:w-1/2">
            <Sidebar />
            <Outlet />
          </div>

        </div>
      </main>

    </React.Fragment>
  )
};

export default Layout;
